var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('course-listing-table',{attrs:{"courseType":_vm.Regular}}),_c('course-listing-table',{attrs:{"courseType":_vm.Live}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }